import { defineComponent } from "vue";
import ScrollAnimation from "@i22/scroll-animation";
import ProductOfferTileMixin from "./component-library230.mjs";
import Heading from "./component-library6.mjs";
import Paragraph from "./component-library5.mjs";
import ProductOfferColorSelect from "./component-library36.mjs";
import ProductOfferShadow from "./component-library231.mjs";
import Prices from "./component-library30.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = defineComponent({
  name: "ProductOfferTile",
  components: {
    LinkButton,
    Prices,
    Heading,
    Paragraph,
    ProductOfferColorSelect,
    ProductOfferShadow
  },
  mixins: [ProductOfferTileMixin, ScrollAnimation],
  props: {
    offerAlternatives: {
      type: Object,
      required: true
    },
    offerImages: {
      type: Object,
      default: void 0
    },
    showAvailableVariant: {
      type: Boolean
    },
    tileSize: {
      type: String,
      default: "s",
      validator(value) {
        return ["s", "m"].includes(value);
      }
    },
    headingTag: { type: String, default: "h2" },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    backgroundColor: {
      type: String,
      default: "light-grey",
      validator(value) {
        return [
          "beige",
          "iceblue",
          "light-grey",
          "light-steel-blue",
          "poison-green",
          "powder-green",
          "powder-lightblue",
          "semi-transparent",
          "violet",
          "white",
          "normal"
        ].includes(value);
      }
    },
    backgroundImage: { type: String, default: "" },
    backgroundPosition: { type: String, default: "" },
    linkTag: { type: String, default: "a" },
    hasVoucher: { type: Boolean },
    animateTile: { type: Boolean },
    animationDelay: { type: Number, default: 1 },
    preTextWasPrice: { type: String, default: "statt" },
    noColorTitle: { type: Boolean }
  },
  computed: {
    tileSizeClassModifier() {
      return this.tileSize === "s" ? "size-s" : "size-m";
    },
    componentClass() {
      const className = "product-offer-tile";
      const classNames = [
        `${className}--${this.backgroundColor}`,
        `${className}--${this.tileSizeClassModifier}`
      ];
      return classNames.join(" ");
    },
    productImageClass() {
      return !this.isHovered ? "product-offer-tile__product-image--visible" : "";
    },
    ambientImageClass() {
      return this.isHovered ? "product-offer-tile__product-image--visible" : "";
    },
    setBackgroundImageSettings() {
      const items = [];
      if (this.backgroundImage)
        items.push(`--bg-image: url(${this.backgroundImage});`);
      if (this.backgroundPosition)
        items.push(`--bg-position: ${this.backgroundPosition};`);
      return items.join(" ");
    }
  },
  mounted() {
    this.createScrollAnimations();
  },
  methods: {
    createScrollAnimations() {
      if (!this.animateTile || !this.$refs.componentRef)
        return;
      this.createScrollTrigger({
        trigger: this.$refs.componentRef,
        start: "top bottom",
        end: "top+=25% bottom",
        scrub: 1,
        // @ts-ignore
        animation: this.createTweenFrom(this.$refs.componentRef, {
          yPercent: 15 * this.animationDelay
        })
      });
    }
  }
});
export {
  _sfc_main as default
};
